import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import NumberFormat from 'react-number-format';
import Skeleton from 'react-loading-skeleton';
import axiosInstance from './../../helpers/axiosInstance';
import MyModal from 'components/Modal/Modal';

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import { normalizeUnits } from 'moment';
import { tr } from 'date-fns/locale';
import { set } from 'date-fns';
import abajo from '../../assets/img/icons/Flecha Abajo.png';
import arriba from '../../assets/img/icons/Flecha Arriba.png';

const _ = require('lodash');

const Paginador = (props) => {
  const Componenteprops = props.Componentepag;
  const [informacion, setinformacion] = useState(props.datos);
  const [numitems, setnumitems] = useState(props.numitems);
  const [numpag, setnumpag] = useState(props.numpag);
  const [pag, setpag] = useState(0);
  const [pagvisibles, setpagvisibles] = useState([]);
  const [indexdatosvisibles, setindexdatosvisibles] = useState([]);
  const [tamañogrande, settamañogrande] = useState(false);
  const [izquierda, setizquierda] = useState(false);
  const [derecha, setderecha] = useState(false);
  const [itemselec, setitemselec] = useState(0);
  const [clasesItems, setclasesItems] = useState([]);

  useEffect(() => {
    console.log('carga de paginador');
    console.log('numero de items ' + numitems);
    console.log('numero de paginas ' + numpag);
    let numelementos = informacion.length;
    if (numpag > 0) {
      if (numelementos / numitems > numpag) {
        settamañogrande(true);
        setderecha(true);
      }
      if (numelementos / numitems > numpag - 1) {
        let indexdatos = [];
        for (let i = 0; i < numitems; i++) {
          indexdatos.push(i);
        }
        setindexdatosvisibles(indexdatos);

        let numpaginas = [];
        let clases = [];
        for (let i = 1; i <= numpag; i++) {
          numpaginas.push(i);
          if (i == 1) {
            clases.push('itempagselec');
          } else {
            clases.push('itempag');
          }
        }
        setclasesItems([...clases]);
        setpagvisibles(numpaginas);
      } else {
        setnumpag(Math.ceil(numelementos / numitems));
        console.log('numero de paginas ' + Math.ceil(numelementos / numitems));
        let n;
        if (numelementos >= numitems) {
          n = numitems;
        } else {
          n = numelementos;
        }

        let indexdatos = [];
        if (n > 0) {
          for (let i = 0; i < n; i++) {
            indexdatos.push(i);
          }
        }
        setindexdatosvisibles(indexdatos);

        let numpaginas = [];
        let clases = [];
        let calnumpag = Math.ceil(numelementos / numitems);
        if (calnumpag > 0) {
          for (let i = 1; i <= calnumpag; i++) {
            numpaginas.push(i);
            if (i == 1) {
              clases.push('itempagselec');
            } else {
              clases.push('itempag');
            }
          }
        }
        setclasesItems([...clases]);
        setpagvisibles(numpaginas);
      }
    }
  }, props.datos);

  const crealista = (pagselec, direccion) => {
    console.log('pagina seleccionada ' + pagselec);
    console.log('direccion seleccionada ' + direccion);

    let posIni = 0;
    if (pagselec > 1) {
      posIni = (pagselec - 1) * numitems;
    }

    let n;
    if (informacion.length - posIni >= numitems) {
      n = numitems;
    } else {
      n = informacion.length - posIni;
    }

    let indexdatos = [];
    if (n > 0) {
      for (let i = 0; i < n; i++) {
        indexdatos.push(i + posIni);
      }
    }
    let clases = [];

    if (settamañogrande && pagselec > 0) {
      if (pagselec * numitems > numitems * numpag) {
        setizquierda(true);
      } else {
        if (pagselec == 1) {
          setizquierda(false);
        }
      }
      if (pagselec * numitems < informacion.length) {
        if (direccion == 1 || direccion == -1) {
          setderecha(true);
        }
      } else {
        setderecha(false);
      }

      if (direccion == 1) {
        let numpaginas = [...pagvisibles];
        numpaginas.splice(0, 1);
        numpaginas.splice(numpag - 1, 0, pagselec);
        for (let i = 0; i < numpaginas.length; i++) {
          if (numpaginas[i] == pagselec) {
            clases.push('itempagselec');
          } else {
            clases.push('itempag');
          }
        }
        setpagvisibles([...numpaginas]);
      } else if (direccion == -1) {
        let numpaginas = [...pagvisibles];
        numpaginas.splice(numpag - 1, 1);
        numpaginas.splice(0, 0, pagselec);
        for (let i = 0; i < numpaginas.length; i++) {
          if (numpaginas[i] == pagselec) {
            clases.push('itempagselec');
          } else {
            clases.push('itempag');
          }
        }
        setpagvisibles([...numpaginas]);
      }
    }

    if (direccion == 0) {
      for (let i = 0; i < pagvisibles.length; i++) {
        if (pagvisibles[i] == pagselec) {
          clases.push('itempagselec');
        } else {
          clases.push('itempag');
        }
      }
    }
    setclasesItems([...clases]);
    setindexdatosvisibles(indexdatos);
    setpag(pagselec - 1);
  };

  const Controlpag = (props) => {
    if (tamañogrande) {
      if (izquierda && derecha) {
        return (
          <div className="compitems">
            <div onClick={() => crealista(pagvisibles[0] - 1, -1)}>
              <img
                src={require('../../assets/img/icons/Flecha Abajo.png').default}
                className="controlespag"
              />
            </div>
            {pagvisibles.map((item, indexcl) => {
              return (
                <div
                  onClick={() => crealista(item, 0)}
                  className={clasesItems[indexcl]}
                >
                  <p className="textopag">{item}</p>
                </div>
              );
            })}
            <div
              onClick={() =>
                crealista(pagvisibles[pagvisibles.length - 1] + 1, 1)
              }
            >
              <img
                src={
                  require('../../assets/img/icons/Flecha Arriba.png').default
                }
                className="controlespag"
              />
            </div>
          </div>
        );
      } else if (izquierda) {
        return (
          <div className="compitems">
            <div onClick={() => crealista(pagvisibles[0] - 1, -1)}>
              <img
                src={require('../../assets/img/icons/Flecha Abajo.png').default}
                className="controlespag"
              />
            </div>
            {pagvisibles.map((item, indexcl) => {
              return (
                <div
                  onClick={() => crealista(item, 0)}
                  className={clasesItems[indexcl]}
                >
                  <p className="textopag">{item}</p>
                </div>
              );
            })}
            <div>
              <h1> </h1>
            </div>
          </div>
        );
      } else {
        return (
          <div className="compitems">
            <div>
              <h1> </h1>
            </div>
            {pagvisibles.map((item, indexcl) => {
              return (
                <div
                  onClick={() => crealista(item, 0)}
                  className={clasesItems[indexcl]}
                >
                  <p className="textopag">{item}</p>
                </div>
              );
            })}
            <div
              onClick={() =>
                crealista(pagvisibles[pagvisibles.length - 1] + 1, 1)
              }
            >
              <img
                src={
                  require('../../assets/img/icons/Flecha Arriba.png').default
                }
                className="controlespag"
              />
            </div>
          </div>
        );
      }
    } else {
      return (
        <div className="compitems">
          <div>
            <h1> </h1>
          </div>
          {pagvisibles.map((item, indexcl) => {
            return (
              <div
                onClick={() => crealista(item, 0)}
                className={clasesItems[indexcl]}
              >
                <p className="textopag">{item}</p>
              </div>
            );
          })}
          <div>
            <h1> </h1>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="cuerpopaginador">
      {indexdatosvisibles.map((item) => {
        console.log(informacion[item]);

        return (
          <Componenteprops
            data={informacion[item]}
            indexelem={item}
          ></Componenteprops>
        );
      })}

      <Controlpag></Controlpag>
    </div>
  );
};

export default Paginador;
